import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { withFormik } from 'formik';
import { useMatomo } from '@datapunt/matomo-tracker-react';
import * as Yup from 'yup';
import { InputBox } from '../components';
import { NUMBER_ERROR_MESSAGE } from '../validation-utils';
import { ErrorList } from '../components/ErrorList';

const ProductInformationSchema = Yup.object().shape({
  products: Yup.array().of(
    Yup.object().shape({
      product_unit_discount_amount:
        Yup.number().typeError(NUMBER_ERROR_MESSAGE),
    })
  ),
});

const formikWrapper = withFormik({
  validationSchema: ProductInformationSchema,
  validateOnMount: false,
  validateOnBlur: false,
  validateOnChange: false,
  mapPropsToValues: (props) => ({
    ...props.initialValues,
  }),
  handleSubmit: (values, formikBag) => {
    values.matomo.trackEvent({
      category: 'Discount Applied',
      action: 'Completed',
    });
    delete values.matomo;
    let next = 'product-review';
    if (
      values.editMode &&
      values.sections.has(`product-review.${values.productIndex}`)
    ) {
      next = 'review-answers';
    }
    values.sections.add(`discount-applied.${values.productIndex}`);
    formikBag.props.updateValues(values, next);
  },
});

const DiscountApplied = ({ handleSubmit, values, setFieldValue }) => {
  const { trackPageView, trackEvent } = useMatomo();
  values.matomo = { trackEvent };
  const history = useHistory();

  useEffect(() => {
    trackPageView();
    trackEvent({
      category: 'Discount Applied',
      action: 'Started',
    });

    window.scrollTo(0, 0);
    document.title = 'Discount applied - Report Suspicious Chemical Activity';
  }, []);

  const index = values.productIndex;
  const productNumber = index + 1;
  const exists = values.products.filter((product) => product.id === index);
  if (exists.length === 0) {
    history.goBack();
    return <></>;
  }

  return (
    <div>
      <a
        className="govuk-back-link"
        href="#"
        onClick={() => {
          if (!values.editMode) {
            setFieldValue(
              `sections`,
              values.sections.delete(`discount-applied.${index}`)
            );
          }
          history.goBack();
        }}
      >
        Back
      </a>
      <main
        className="govuk-main-wrapper govuk-main-wrapper--auto-spacing"
        id="content"
        role="main"
        tabIndex={0}
      >
        <div className="govuk-grid-row">
          <div className="govuk-grid-column-two-thirds">
            <ErrorList />
            <span className="govuk-caption-l">Product {productNumber}</span>
            <form onSubmit={handleSubmit}>
              <div className="govuk-grid-column">
                <InputBox
                  isNumber={true}
                  name={`products.${index}.product_unit_discount_amount`}
                  size="5"
                  questionLarge="What was the item price with the discount applied?"
                />
              </div>
              <button
                type="submit"
                data-prevent-double-click="true"
                className="govuk-button"
                data-module="govuk-button"
                data-test={`button-continue`}
                aria-label="continue"
              >
                Continue
              </button>
            </form>
          </div>
        </div>
      </main>
    </div>
  );
};

const DiscountAppliedWithFormik = formikWrapper(DiscountApplied);

export { DiscountAppliedWithFormik as DiscountApplied };
